<template>
<input type="text" class="form-control" :value="value" @input="$emit('input', $event.target.value)">
</template>

<script>
export default {
  props: {
    value: {type: String, required: true}
  }
}
</script>



// WEBPACK FOOTER //
// TextInput.vue?4a9f6b50